import React, { Component } from "react";
import { connect } from "react-redux";
import PaymentDetailsRow from "./PaymentDetailsRow";

export class InvoiceBreakdown extends Component {
  render() {
    let invoiceRows;

    if (this.props.treatments) {
      invoiceRows = this.props.treatments.map((treatment, index) => (
        <PaymentDetailsRow key={index} treatment={treatment} />
      ));
    }
    return (
      <div id="treatments" className="pt-4 mt-2">
        {invoiceRows}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  treatments:
    state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Treatments
});

export default connect(mapStateToProps)(InvoiceBreakdown);
